<template>
<b-container fluid id="infopoint-view">
    <b-row>
        <b-col cols="9">
            <card>
                <InfopointTable
                    ref="infopointTable"
                    @selectItem="onSelectItem"
                    @newItem="onNewItem"
                    :item="item ? item.id : null">
                </InfopointTable>
            </card>
        </b-col>
        <b-col cols="3">
            <InfoCard v-if="action == ''"></InfoCard>

            <card v-if="action == 'new'">
                <CardHeader :title="$t('item.new')"/>
                <InfopointEditor :item="item" action="new" @itemSaved="onSelectItem"/>
            </card>

            <card v-if="action == 'item' && item">
                <CardHeader :title="item ? item.uniqueId: ''" type="item" />
                <tabs>
                    <tab-pane title="tab-1" key="tab-1" v-if="$UIPrivilege('devices/infopoints', 'screenshot')">
                        <b-icon id="screenshot" slot="title" icon="aspect-ratio" scale='1.1'></b-icon>
                        <b-popover target="screenshot" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.screenshot")}}
                        </b-popover>
                        <InfopointScreenshot :item="item" />
                        <ScreenshotHistory :item="item.device" v-if="$UIPrivilege('devices/infopoints', 'screenshot.history')"/>
                    </tab-pane>
                    <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('devices/infopoints', 'actions')">
                        <b-icon id="actions-icon" slot="title" icon="arrow-left-right" scale='1.1'></b-icon> 
                        <b-popover target="actions-icon" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.actions")}}
                        </b-popover>
                        <InfopointActions :item="item" />
                    </tab-pane>
                    <tab-pane  title="tab-3" key="tab-3" v-if="$UIPrivilege('devices/infopoints', 'status')">
                         <b-icon id="status-icon" slot="title" icon="bar-chart" scale='1.1'></b-icon>
                         <b-popover target="status-icon" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.status")}}
                        </b-popover>
                        <InfopointStatus :infopoint='item'/>
                    </tab-pane>
                    <tab-pane  title="tab-4" key="tab-4" v-if="$UIPrivilege('devices/infopoints', 'layout')">
                        <b-icon id="columns" slot="title" icon="columns" scale='1.1'></b-icon>
                        <b-popover target="columns" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.layout")}}
                        </b-popover>
                        <InfopointTimetableViews :item="item" />
                    </tab-pane>
                     <tab-pane  title="tab-5" key="tab-5" v-if="$UIPrivilege('devices/infopoints', 'settings')"> 
                        <b-icon id="card-list" slot="title" icon="card-list" scale='1.1'></b-icon>
                        <b-popover target="card-list" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.settings")}}
                        </b-popover>
                        <InfopointEditor :item="item" action="edit" />
                    </tab-pane>
                    <!--tab-pane  title="tab-6" key="tab-6" v-if="$UIPrivilege('devices/infopoints', 'channel.layout')">
                        <b-icon id="channel-layout" slot="title" icon="columns" scale='1.1'></b-icon>
                        <b-popover target="channel-layout" triggers="hover" placement="top">
                            {{$t("infopoints.tooltips.channel_layout")}}
                        </b-popover>
                        <InfopointChannels :item="item" />
                    </tab-pane-->
                </tabs>
            </card>   
 
        </b-col>
    </b-row>
</b-container>
</template>

<script>

import InfopointTable from '@/components/Devices/Infopoints/InfopointTable'
import InfopointActions from '@/components/Devices/Infopoints/InfopointActions'
import InfopointScreenshot from '@/components/Devices/Infopoints/InfopointScreenshot'
import InfopointStatus from '@/components/Devices/Infopoints/InfopointStatus'
import InfopointEditor from '@/components/Devices/Infopoints/InfopointEditor'
import InfopointTimetableViews from '@/components/Devices/Infopoints/InfopointTimetableViews'
/*import InfopointChannels from '@/components/Devices/Infopoints/InfopointChannels'*/
import ScreenshotHistory from '@/components/Devices/ScreenshotHistory'

export default {
    name: 'Infopoints',
    components: {
        InfopointTable, 
        InfopointActions, 
        InfopointScreenshot, 
        InfopointStatus, 
        InfopointEditor, 
        InfopointTimetableViews,
       /* InfopointChannels,*/
        ScreenshotHistory
    },
    data: function() {
        return {
            action: "",
            item: {}
        }
    },
    mounted() {
      if(this.$route.query.uniqueId) {
        var filtervalue = this.$route.query.uniqueId;
        this.$refs.infopointTable.setFilterValue(filtervalue);
      }
    },
    watch: {
        item(){
            //if(!this.item) this.action = "";
        } 
    },
    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"

            /* 
                hide other elements on mobile?
            */
            /*
            var element = document.querySelector("#item-card");
            element.scrollIntoView();
            */
        }
    }
}
</script>
